import { Err, Ok } from "ts-results-es";
import { ExtendedError } from "./error.js";
import * as ErrorCode from "./errorCode.js";
import { ErrorType } from "./errorrType.js";
import { optionOf } from "./option.js";
export class NotFoundError extends ExtendedError {
    what;
    where;
    constructor(what, where) {
        super(optionOf(what).mapOr("Not found", (what) => `Not found: ${what}`), ErrorCode.NotFound.description);
        this.what = what;
        this.where = where;
    }
    get detailedMessage() {
        const what = this.what ?? "Not found";
        const where = this.where ? ` in ${this.where}` : "";
        return `Not found: ${what}${where}`;
    }
    expose = true;
    get tag() {
        return ErrorCode.NotFound;
    }
    get type() {
        return ErrorType.NotFound;
    }
    static fromOption(option, ...params) {
        return option.isSome()
            ? Ok(option.value)
            : Err(new NotFoundError(...params));
    }
}
export class TimeoutError extends ExtendedError {
    what;
    constructor(what) {
        super(`${what ?? "A task"} took too long`);
        this.what = what;
    }
    expose = false;
    get tag() {
        return ErrorCode.Timeout;
    }
}
export class InvalidOperationError extends ExtendedError {
    what;
    constructor(what) {
        super(`Invalid operation: ${what}`, ErrorCode.InvalidOperation.description);
        this.what = what;
    }
    expose = false;
    get tag() {
        return ErrorCode.InvalidOperation;
    }
    get type() {
        return ErrorType.BadRequest;
    }
}
export class InvalidArgumentError extends ExtendedError {
    what;
    constructor(what) {
        super(`Invalid argument: ${what}`, ErrorCode.InvalidArgument.description);
        this.what = what;
    }
    expose = false;
    get tag() {
        return ErrorCode.InvalidArgument;
    }
    get type() {
        return ErrorType.BadRequest;
    }
}
export class InvalidStateError extends ExtendedError {
    what;
    constructor(what) {
        super(`Invalid state: ${what}`, ErrorCode.InvalidState.description);
        this.what = what;
    }
    expose = false;
    get tag() {
        return ErrorCode.InvalidState;
    }
}
export class InvariantError extends ExtendedError {
    what;
    constructor(what) {
        super(`Invariant violation: ${what}`, ErrorCode.InvariantViolation.description);
        this.what = what;
    }
    expose = false;
    get tag() {
        return ErrorCode.InvariantViolation;
    }
}
//# sourceMappingURL=direct.js.map